export const MAX_GUESSES = 6;
export const ALERT_TIME_MS = 1000;
export const REVEAL_TIME_MS = 350;
